import React from 'react'
import { component_tool } from '@/tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'groupId',
            name: 'groupId',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'delFlag',
            name: 'delFlag',
            formItem: {
                type: 'hidden'
            }
        },

        {
            title: '用户组名称',
            name: 'name',
            tableItem: {},
        },
        {
            title: '用户组名称',
            name: 'searchName',
            searchItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入用户组名称'
                }],
            }
        },
        {
            title: '用户组编码',
            name: 'code',
            tableItem: {},
        },
        {
            title: '用户组编码',
            name: 'searchCode',
            searchItem: {},
            formItem: {
                type: 'hidden',
                rules: [{
                    required: true,
                    message: '请输入用户组编码'
                }],
            }
        },
        
        {
            title: "状态",
            name: "state",
            dataIndex: "state",
            tableItem: {},
            dict: [
              { code: 'ENABLE', codeName: "启用" },
              { code: 'PROHIBIT', codeName: "禁用" }
            ],
            formItem: {
              type: "select"
            }
          }
       
    ]
}